// * GET =====================================
export const AUTH_GET_ME = `/auth/me`;

/**
 * The global, admin-restricted sessions listing on the backend - there is
 * currently no personal-sessions endpoint.
 */
export const AUTH_GET_SESSIONS = `/auth/sessions`;

export const AUTH_GET_ACTIVE_SESSIONS = `/auth/active-sessions`;

// * PATCH ===================================

// * POST ====================================
export const AUTH_POST_LOGIN = `/auth/login`;

export const AUTH_POST_LOGOUT = `/auth/logout`;

export const AUTH_POST_AUTH_TOKEN = `/auth/auth_token`;

export const AUTH_POST_REFRESH = `/auth/refresh`;

// * DELETE ==================================
export const AUTH_DELETE_SESSIONS = `/auth/sessions`;

// * PUT =====================================
